<!-- <div class="pdq-item">
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
        <h2>PDQv3</h2>
    </div>
    <div class="source">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div fxLayout="column">Source </div>
            <div fxLayout="column">
                <input nz-input type="text" [(ngModel)]="ip" />
            </div>
            <div fxLayout="column">:</div>
            <div fxLayout="column" fxFlex="70px">
                <input nz-input type="number" [(ngModel)]="port" />
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="">
        <div fxLayout="column" fxFlex="90" class="file-row">
            <input type="file" accept=".xml" (change)="onFileChange($event)" />
        </div>
        <div fxLayout="column" fxFlex="10">
            <button nz-button (click)="pdqv3()" [disabled]="!!!soapFile">PDQv3</button>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="pdq-container">
        <div fxLayout="column" fxFlex="90">
            <textarea [rows]="resultRows" nz-input class="text-area-pdq" [value]="result" [disabled]="true"></textarea>
        </div>
        <div fxLayout="column" fxFlex="10">
        </div>
    </div>
</div> -->



<div class="pdq-item">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
    <h2>PDQv3</h2>
  </div>

  <!-- Source Info (Optional for now since you're hardcoding endpoint) -->
  <!--
  <div class="source">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxLayout="column">Source</div>
      <div fxLayout="column"><input nz-input type="text" [(ngModel)]="ip" /></div>
      <div fxLayout="column">:</div>
      <div fxLayout="column" fxFlex="70px"><input nz-input type="number" [(ngModel)]="port" /></div>
    </div>
  </div>
  -->

  <!-- Predefined Query Buttons -->
  <div fxLayout="column" fxLayoutGap="5px" style="margin: 10px 0;">
    <button nz-button nzType="default" (click)="runthisquery('exactName')">Search by Name: MOORE CHIP</button>
    <button nz-button nzType="default" (click)="runthisquery('fuzzyName')">Fuzzy Name: MO</button>
    <button nz-button nzType="default" (click)="runthisquery('byId')">Search by ID: IHEGREEN-993</button>
    <button nz-button nzType="default" (click)="runthisquery('byBirth')">BirthDate: 19780920</button>
    <button nz-button nzType="default" (click)="runthisquery('nameAndGender')">Name: MO & Gender: F</button>
    <button nz-button nzType="default" (click)="runthisquery('nameAndBirth')">Name + DOB: MOORE + 19510706</button>
    <button nz-button nzType="default" (click)="runthisquery('nameAndAddress')">Name + Addr: MOORE + 10 PINETREE</button>
  </div>

  <!-- Optional XML upload (keep if you want both methods) -->
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start">
    <div fxLayout="column" fxFlex="90" class="file-row">
      <input type="file" accept=".xml" (change)="onFileChange($event)" />
    </div>
    <div fxLayout="column" fxFlex="10">
      <button nz-button (click)="pdqv3()" [disabled]="!!!soapFile">Send Uploaded XML</button>
    </div>
  </div>

  <!-- Response output -->
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="pdq-container">
    <div fxLayout="column" fxFlex="90">
      <textarea [rows]="resultRows" nz-input class="text-area-pdq" [value]="result" [disabled]="true"></textarea>
    </div>
  </div>
</div>
